import { FunctionalComponent, h } from "@stencil/core";

interface FooterProps {
    primaryButtonLabel: string;
    secondaryButtonLabel?: string;
    secondaryButtonType?: "link" | "button";
    onPrimaryButtonClick: (event: UIEvent) => void;
    onSecondaryButtonClick?: (event: UIEvent) => void;
}

export const Footer: FunctionalComponent<FooterProps> = ({
    primaryButtonLabel,
    secondaryButtonLabel = "",
    secondaryButtonType = "button",
    onPrimaryButtonClick,
    onSecondaryButtonClick,
}) => {
    const hasSecondaryButton =
        secondaryButtonLabel !== "" &&
        typeof onSecondaryButtonClick !== "undefined";
    return (
        <ux-cookie-layer-footer>
            {hasSecondaryButton && secondaryButtonType !== "link" && (
                <button
                    type="button"
                    class="ux-cookie-layer__button ux-cookie-layer__button--secondary"
                    onClick={onSecondaryButtonClick}
                >
                    {secondaryButtonLabel}
                </button>
            )}
            {hasSecondaryButton && secondaryButtonType === "link" && (
                <div class="ux-cookie-layer__link">
                    <a
                        href="#"
                        class="ux-cookie-layer__nav-item"
                        onClick={onSecondaryButtonClick}
                    >
                        {secondaryButtonLabel}
                    </a>
                </div>
            )}
            {hasSecondaryButton && (
                <span class="ux-cookie-layer-footer__spacer" />
            )}
            <button
                type="button"
                class="ux-cookie-layer__button ux-cookie-layer__button--primary"
                onClick={onPrimaryButtonClick}
            >
                {primaryButtonLabel}
            </button>
        </ux-cookie-layer-footer>
    );
};
